var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-space-around-no tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tab-item",class:_vm.tabsIndex === index ? 'active' : 'reverse',on:{"click":function($event){return _vm.handleTabs(index)}}},[_vm._v(_vm._s(tab))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }